import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  background-color: rgba(256, 256, 256, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;